// Prikaz isteka ugovora / kredita firme. Datumi su lokalni `YYYY-MM-DD` bez
// vremena, pa se računaju kao kalendarski dani, bez vremenske zone.
import { formatDateWithOptionsBs } from "@/lib/format";

export type ExpiryState = "ok" | "soon" | "expired";

export function daysUntil(ymd: string, todayYmd: string): number {
  return Math.round((Date.parse(`${ymd}T00:00:00Z`) - Date.parse(`${todayYmd}T00:00:00Z`)) / 86_400_000);
}

export function expiryState(ymd: string, todayYmd: string, soonDays = 30): ExpiryState {
  const d = daysUntil(ymd, todayYmd);
  if (d < 0) return "expired";
  return d <= soonDays ? "soon" : "ok";
}

/** "20. novembar 2026." za lokalni datum `YYYY-MM-DD`. */
export function formatLocalYmd(ymd: string): string {
  // Podne UTC je isti kalendarski dan u Sarajevu u svakom godišnjem dobu.
  return formatDateWithOptionsBs(`${ymd}T12:00:00Z`, {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "Europe/Sarajevo",
  });
}

export function expiryLabel(ymd: string, todayYmd: string): string {
  const d = daysUntil(ymd, todayYmd);
  if (d < 0) return "istekao";
  if (d === 0) return "ističe danas";
  return `ističe za ${d} ${d === 1 ? "dan" : "dana"}`;
}

/** Današnji lokalni datum u browseru (Sarajevo). */
export function todayYmd(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Sarajevo", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
  return parts;
}
